import { render } from "./index.vue?vue&type=template&id=2231db8e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=2231db8e&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-2231db8e"

export default script